module.exports = __webpack_public_path__ + "static/tools-resources-photo-02-9fe6640e974d54b7641d88add73350e6.jpg";